import { useState } from "react";
import ReactECharts from "echarts-for-react";

import { useGetFarmerAnimals } from "@/features/Animals/animalApiSlice.ts";

const Chart = () => {
  const [count, setCount] = useState(0);
  const { data } = useGetFarmerAnimals();

  const maleAnimals =
    data && Array.isArray(data)
      ? data.filter((item: any) => item.sex === "male").length
      : 0;
  const femaleAnimals =
    data && Array.isArray(data)
      ? data.filter((item: any) => item.sex === "female").length
      : 0;

  const option = {
    xAxis: {
      type: "category",
      data: ["Male", "Female"],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: [maleAnimals, femaleAnimals],
        type: "bar",
      },
    ],
  };

  function onChartReady() {
    // console.log("echarts is ready", echarts);
  }

  function onChartClick() {
    // console.log(param, echarts);
    setCount(count + 1);
  }

  function onChartLegendSelectChanged() {}

  return (
    <ReactECharts
      option={option}
      style={{ height: 400 }}
      onChartReady={onChartReady}
      onEvents={{
        click: onChartClick,
        legendselectchanged: onChartLegendSelectChanged,
      }}
    />
  );
};

export default Chart;
